import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "width", "primary", "secondary", "color", "style"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import { ChildrenPropType, StylePropType } from '../../../../services/proptypes';
import GridColumnFlex from '../../../GridColumnFlex';
var defaultProps = {
  children: null,
  color: 'transparent',
  primary: false,
  secondary: false,
  width: null,
  style: {}
};
function Color(_ref) {
  var children = _ref.children,
    width = _ref.width,
    primary = _ref.primary,
    secondary = _ref.secondary,
    color = _ref.color,
    style = _ref.style,
    columnProps = _objectWithoutProperties(_ref, _excluded);
  var extraClasses = '';
  if (primary) {
    extraClasses = ' primary';
  } else if (secondary) {
    extraClasses = ' secondary';
  }
  var styles = primary || secondary ? {} : {
    backgroundColor: color
  };
  return /*#__PURE__*/React.createElement(GridColumnFlex, _extends({
    className: "color-component".concat(extraClasses),
    width: width,
    style: _objectSpread(_objectSpread({}, styles), style)
  }, columnProps), children);
}
Color.defaultProps = defaultProps;
export default Color;